var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticStyle:{"padding":"0px 8px 0px 8px","margin":"6px 4px"},attrs:{"color":"primary","outline":""},on:{"click":_vm.onExport}},[_vm._v("\n    "+_vm._s(_vm.$t('demo_file'))+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45cbc8e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/ecommerce/demoFile.vue
// module id = null
// module chunks = 